// extracted by mini-css-extract-plugin
module.exports = {"panelling":"style_panelling__2km4_","bgg":"style_bgg__2YLyj","wrapp":"style_wrapp__XQsA0","contii":"style_contii__38Ge6","title":"style_title__1KsGL","myp":"style_myp__22lwl"};